import React, { useEffect, useState } from 'react'
import {
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableSelectAll,
  TableSelectRow,
  TableContainer,
  Pagination,
} from 'carbon-components-react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { saveWatchfolder, loadWatchfolders, selectToken, selectWatchfolderResult, deleteWatchfolder, toggleWatchfolder } from '../../../AppSlice';
import Icon, { Icons } from '../../Icon/Icon';
import { CreateTaskModal } from './CreateTaskModal';
import { ConfirmModal } from '../../ConfirmModal';
import { CleanupModal } from './CleanupModal';
import { LogsModal } from './LogsModal';
import moment from 'moment';
import { emptyWatchfolder, IWatchfolder } from './Watchfolder.model';

const headers = [
  { key: 'label', header: 'Name' },
  { key: 'path', header: 'Path' },
  { key: 'status', header: 'Status' },
  { key: 'enabled', header: 'Enabled' },
  { key: 'createdTimestamp', header: 'Created At' },
  { key: 'targetService', header: 'System' },
];

interface IActions {
  [key: string]: {
    title: string;
    icon: keyof typeof Icons;
    isDisabled: boolean;
  }
}
const actions: IActions = {
  "new": { title: 'New Folder', icon: "newFolder", isDisabled: false },
  "edit": { title: 'Edit', icon: "edit", isDisabled: false },
  "delete": { title: 'Delete', icon: "delete", isDisabled: false },
  "pause": { title: 'Pause', icon: "control_pause", isDisabled: false },
  "resume": { title: 'Resume', icon: "control_play", isDisabled: false },
  "clean": { title: 'Clean', icon: "erase", isDisabled: false },
  "refresh": { title: 'Refresh', icon: "refresh", isDisabled: false },
}

function Watchfolder() {

  const dispatch = useAppDispatch()

  const [filterStatus, setFilterStatus] = useState<string>('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [pauseModalOpen, setPauseModalOpen] = useState(false);
  const [resumeModalOpen, setResumeModalOpen] = useState(false);
  const [cleanModalOpen, setCleanModalOpen] = useState(false);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const [selected, setSelected] = useState([])
  const [filteredActions, setFilteredActions] = useState<IActions>({})
  const [modelWatchfolder, setModelWatchfolder] = useState<IWatchfolder>(null)

  const watchfolderResult = useAppSelector(selectWatchfolderResult)
  const token = useAppSelector(selectToken)

  useEffect(() => {
    loadWatchfolder()
  }, [currentPage, rowsPerPage])

  const loadWatchfolder = () => {
    dispatch(loadWatchfolders({ token, page: currentPage - 1, size: rowsPerPage }))
  }

  const filteredWatchfolders = filterStatus === 'All'
    ? watchfolderResult?.content
    : watchfolderResult?.content?.filter((watchfolder) => watchfolder.status?.toLowerCase() === filterStatus.toLowerCase());


  const rows = filteredWatchfolders.map((watchfolder) => ({ id: watchfolder.id, ...watchfolder }));


  useEffect(() => {
    let factions: IActions = {}
    Object.keys(actions).forEach(action => {

      let isDisabled = (['delete', 'pause', 'resume'].includes(action) && selected.length === 0) || (['edit', 'clean'].includes(action) && selected.length !== 1)
      if (!isDisabled) isDisabled = action === "resume" && rows.filter(w => selected.includes(w.id) && !w.enabled).length === 0
      if (!isDisabled) isDisabled = action === "pause" && rows.filter(w => selected.includes(w.id) && w.enabled).length === 0
      factions[action] = { ...actions[action], isDisabled }
    })
    setFilteredActions(factions)
  }, [selected, rows])

  const getStatusClass = (status: string): string => {
    switch (status?.toLowerCase()) {
      case 'working':
        return 'progress-success';
      case 'error':
        return 'progress-danger';
      case 'paused':
        return 'progress-warning';
      default:
        return 'progress-default';
    }
  };

  const onActionClick = (action, selectedRows) => {
    // setSelectedRows(selectedRows)
    switch (action) {
      case "new":
        setModelWatchfolder(emptyWatchfolder)
        setEditModalOpen(true)
        break;
      case "edit":
        setModelWatchfolder(selectedRows?.length > 0 ? rows.find(w => w.id === selectedRows[0].id) : null)
        setEditModalOpen(true)
        break;
      case "delete":
        setDeleteModalOpen(true)
        break;
      case "pause":
        setPauseModalOpen(true)
        break;
      case "resume":
        setResumeModalOpen(true)
        break;
      case "clean":
        setCleanModalOpen(true)
        break;
      case "logs":
        setLogModalOpen(true)
        break;
      case "refresh":
        loadWatchfolder()
        break;

      default:
        break;
    }
  }

  const handleCreateTask = (watchfolder: IWatchfolder) => {
    dispatch(saveWatchfolder({ token, watchfolder }))
    setTimeout(() => {
      loadWatchfolder()
    }, 200);
  };

  const handleDeleteWatchfolder = () => {
    dispatch(deleteWatchfolder({ token, ids: selected }))
    setDeleteModalOpen(false)
    setSelected([])
    setTimeout(() => {
      loadWatchfolder()
    }, 2000);
  };

  const handleToggleWatchfolder = (enable) => {
    dispatch(toggleWatchfolder({ token, ids: selected, toDisable: !enable }))
    setPauseModalOpen(false)
    setResumeModalOpen(false)
    setTimeout(() => {
      loadWatchfolder()
    }, 2000);
  };

  return (
    <>

      <TableContainer>
        <DataTable
          rows={rows}
          headers={headers}
          isSortable

          render={({
            rows,
            headers,
            getHeaderProps,
            getRowProps,
            getTableProps,
            getSelectionProps,
            // getExpandHeaderProps,
            // getExpandRowProps,
            selectedRows,
          }) => {

            if (JSON.stringify(selectedRows.map(w => w.id)) !== JSON.stringify(selected)) {
              setSelected(selectedRows.map(w => w.id));
            }

            return (<>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="status-filters">
                  {Object.keys(filteredActions)
                    .map((action) => {
                      return <div
                        key={action}
                        className={`action-box action-${action} ${filteredActions[action].isDisabled ? 'disabled' : ''}`}
                        onClick={() => {
                          if (!filteredActions[action].isDisabled) {
                            onActionClick(action, selectedRows)
                          }
                        }}
                      >
                        <Icon type={filteredActions[action].icon} color='white' size={16} />
                        <div style={{ fontSize: 13, marginTop: 2 }}>
                          {filteredActions[action].title}
                        </div>
                      </div>
                    }
                    )}
                  <div style={{ width: 20 }} />
                  {/* {['All', 'Working', 'Paused', 'Error'].map((status) => ( */}
                  <div
                    className={`status-box ${getStatusClass("All")} ${filterStatus === "All" ? 'active' : ''}`}
                    style={{ borderWidth: filterStatus === "All" ? 3 : 1 }}
                  // onClick={() => setFilterStatus(status)}
                  >
                    <div>
                      {"All"}
                    </div>
                    <div style={{ marginTop: 4 }}>
                      {watchfolderResult?.content?.length}
                    </div>
                  </div>
                  <div
                    className={`status-box ${getStatusClass("Working")} ${filterStatus === "Working" ? 'active' : ''}`}
                    style={{ borderWidth: filterStatus === "Working" ? 3 : 1 }}
                  // onClick={() => setFilterStatus(status)}
                  >
                    <div>
                      {"Working"}
                    </div>
                    <div style={{ marginTop: 4 }}>
                      {watchfolderResult?.content?.filter((watchfolders) => watchfolders.enabled).length}
                    </div>
                  </div>
                  <div
                    className={`status-box ${getStatusClass("Paused")} ${filterStatus === "Paused" ? 'active' : ''}`}
                    style={{ borderWidth: filterStatus === "Paused" ? 3 : 1 }}
                  // onClick={() => setFilterStatus(status)}
                  >
                    <div>
                      {"Paused"}
                    </div>
                    <div style={{ marginTop: 4 }}>
                      {watchfolderResult?.content?.filter((watchfolders) => !watchfolders.enabled).length}
                    </div>
                  </div>

                  <div
                    className={`status-box ${getStatusClass("Error")} ${filterStatus === "Error" ? 'active' : ''}`}
                    style={{ borderWidth: filterStatus === "Error" ? 3 : 1 }}
                  // onClick={() => setFilterStatus(status)}
                  >
                    <div>
                      {"Error"}
                    </div>
                    <div style={{ marginTop: 4 }}>
                      {watchfolderResult?.content?.filter((watchfolders) => watchfolders.status === "error").length}
                    </div>
                  </div>

                  {/* ))} */}
                </div>
                <div className="status-filters">
                  <div
                    className={`action-box action-log`}
                    onClick={() => onActionClick('logs', selectedRows)}
                  >
                    <Icon type='text' color='white' size={16} />
                    <div style={{ fontSize: 13, marginTop: 2 }}>
                      Log
                    </div>
                  </div>
                </div>
              </div>

              <Table {...getTableProps()}>
                <TableHead>
                  <TableRow>
                    {/* <TableExpandHeader {...getExpandHeaderProps()} /> */}
                    <TableSelectAll {...getSelectionProps()} />
                    {headers.map((header) => (
                      <TableHeader key={header.key} {...getHeaderProps({ header })}>
                        {header.header}
                      </TableHeader>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.id}>
                      <TableSelectRow {...getSelectionProps({ row })} />
                      {/* {row.status} */}
                      {row.cells.map((cell) => {
                        if (cell.info.header === 'progress') {
                          const statusClass = getStatusClass(row.cells.find(cell => cell.id === row.id + ":status").value);
                          const value = row.progress;

                          return (
                            <TableCell key={cell.id}>
                              <div className="progress-bar-container">
                                <div className={`progress-bar ${statusClass}`}>
                                  <div
                                    className="progress-bar-fill"
                                    style={{ width: `${cell.value}%` }}
                                  />
                                </div>
                                {/* <div className="progress-label">{cell.value}%</div> */}
                              </div>
                            </TableCell>
                          );
                        }
                        if (cell.info.header === 'createdTimestamp') {
                          return (
                            <TableCell key={cell.id}>
                              {moment(cell.value).format("DD.MM.YYYY HH:mm:ss")}
                            </TableCell>
                          );
                        }
                        if (cell.info.header === 'enabled') {
                          return (
                            <TableCell key={cell.id}>
                              {cell.value ? <Icon type='control_play' color='green' size={18} /> : <Icon type='control_pause' color='yellow' size={18} />}
                            </TableCell>
                          );
                        }
                        if (cell.info.header === 'status') {
                          return (
                            <TableCell key={cell.id}>
                                 {<span style={{ color: cell.value === "error" ? "red": "green"}}>{cell.value?.toUpperCase()}</span>}
                            </TableCell>
                          );
                        }
                        return <TableCell key={cell.id}>{cell.value}</TableCell>;
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </>
            );
          }}
        />

        <Pagination
          totalItems={watchfolderResult?.totalElements ?? 0}
          pageSize={rowsPerPage}
          pageSizes={[5, 10, 20, 50]}
          page={currentPage}
          onChange={({ page, pageSize }) => {
            setCurrentPage(page);
            setRowsPerPage(pageSize);
          }}
        />

      </TableContainer>

      <CreateTaskModal
        open={editModalOpen}
        watchfolder={modelWatchfolder}
        onClose={() => setEditModalOpen(false)}
        onSubmit={handleCreateTask}
      />

      <ConfirmModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDeleteWatchfolder}
        title="Confirm Delete"
        message={`Are you sure you want to delete ${selected?.length === 1 ? "Watchfolder: " : selected?.length} ${selected?.length === 1 ? JSON.stringify(rows.find(w => w.id === selected[0])?.label) : "watchfolders"}? This action cannot be undone.`}
        type={"danger"}
      />

      <ConfirmModal
        open={pauseModalOpen}
        onClose={() => setPauseModalOpen(false)}
        onConfirm={() => handleToggleWatchfolder(false)}
        title="Confirm Pause"
        message={`Are you sure you want to pause : ${selected?.length === 1 ? "Watchfolder: " : selected?.length} ${selected?.length === 1 ? JSON.stringify(rows.find(w => w.id === selected[0])?.label) : "watchfolders"}?`}
        type={"danger"}
      />

      <ConfirmModal
        open={resumeModalOpen}
        onClose={() => setResumeModalOpen(false)}
        onConfirm={() => handleToggleWatchfolder(true)}
        title="Confirm Resume"
        message={`Are you sure you want to resume : ${selected?.length === 1 ? "Watchfolder: " : selected?.length} ${selected?.length === 1 ? JSON.stringify(rows.find(w => w.id === selected[0])?.label) : "watchfolders"}?`}
        type={"danger"}
      />

      <CleanupModal
        open={cleanModalOpen}
        watchfolderId={selected.length === 1 ? selected[0] : null}
        token={token}
        onClose={() => setCleanModalOpen(false)}
      />

      <LogsModal
        open={logModalOpen}
        onClose={() => setLogModalOpen(false)}
        onSubmit={handleCreateTask}
      />

    </>
  )
}

export default Watchfolder